import '@fontsource/libre-franklin';
import '@fontsource/karla';
import '@fontsource/space-grotesk';
import './global.scss';

import { Analytics } from '@vercel/analytics/react';
import ContactUsButton from './components/contactUsFloatingButton/contactUsButton';
import CssBaseline from '@mui/material/CssBaseline';
import Notifier from './components/notifier/notifier';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { router } from './appConfig/appRouter';
import { store } from './store/store';
import theme from './theme/theme';

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}
const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <Analytics />
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Notifier />
                <RouterProvider router={router} />
                <ContactUsButton />
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
);
